export class ServiceDetailViewModel {
    constructor() {
        this.name = "";
        this.latestVersion = null;
        this.description = null;
        this.url = null;
    }
}
export default class ServiceDetailView extends ServiceDetailViewModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
